import { c as _c } from "react/compiler-runtime";
import { IconChevronRightOutline18 } from "nucleo-ui-outline-18";
import { Badge } from "@/components/ui/badge";
import { NodeIconTile } from "@/components/ui/node-icon-tile";
import Link from "next/link";
interface IntegrationHeaderProps {
  integration: {
    type: string;
    name: string;
    connector?: {
      type: string;
    };
    platform?: string;
    description?: string;
    logoUrl?: string;
  };
  isTrigger: boolean;
  connectorLogoUrl?: string;
  cleanDescription?: string;
  costDisplay?: string | null;
}
export function IntegrationHeader(t0) {
  const $ = _c(43);
  const {
    integration,
    isTrigger,
    connectorLogoUrl,
    cleanDescription,
    costDisplay
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/integrations" className="hover:text-ds-text-primary dark:hover:text-white">Integrations</Link>;
    t2 = <IconChevronRightOutline18 className="h-3.5 w-3.5" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = `/integrations?tab=${isTrigger ? "triggers" : "actions"}`;
  const t4 = isTrigger ? "Triggers" : "Actions";
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = <Link href={t3} className="hover:text-ds-text-primary dark:hover:text-white">{t4}</Link>;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconChevronRightOutline18 className="h-3.5 w-3.5" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== integration.name) {
    t7 = <span className="text-ds-text-primary font-medium">{integration.name}</span>;
    $[6] = integration.name;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t7) {
    t8 = <div className="text-ds-text-muted mb-6 flex items-center gap-1.5 text-sm">{t1}{t2}{t5}{t6}{t7}</div>;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = integration.description ?? "";
  let t10;
  if ($[11] !== connectorLogoUrl || $[12] !== integration.connector) {
    t10 = integration.connector ? {
      type: integration.connector.type,
      logoUrl: connectorLogoUrl
    } : undefined;
    $[11] = connectorLogoUrl;
    $[12] = integration.connector;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = isTrigger ? "#2450FF" : "#22c55e";
  let t12;
  if ($[14] !== integration.logoUrl || $[15] !== integration.name || $[16] !== integration.type || $[17] !== t10 || $[18] !== t11 || $[19] !== t9) {
    t12 = <NodeIconTile size="lg" id={integration.type} subject={integration.name} context={t9} logoUrl={integration.logoUrl} connector={t10} alt={integration.name} color={t11} />;
    $[14] = integration.logoUrl;
    $[15] = integration.name;
    $[16] = integration.type;
    $[17] = t10;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== integration.name) {
    t13 = <h1 className="text-ds-text-primary text-3xl font-bold tracking-tight">{integration.name}</h1>;
    $[21] = integration.name;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = `rounded-full px-3 py-1 text-sm font-medium ${isTrigger ? "bg-yellow-50 text-yellow-700 dark:bg-yellow-500/10 dark:text-yellow-400" : "bg-green-50 text-green-700 dark:bg-green-500/10 dark:text-green-400"}`;
  const t15 = isTrigger ? "Trigger" : "Action";
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <span className={t14}>{t15}</span>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== costDisplay) {
    t17 = costDisplay && <Badge variant="info" className="px-3 py-1 text-sm">{costDisplay}</Badge>;
    $[26] = costDisplay;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t13 || $[29] !== t16 || $[30] !== t17) {
    t18 = <div className="mb-2 flex items-center gap-3">{t13}{t16}{t17}</div>;
    $[28] = t13;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== cleanDescription) {
    t19 = <p className="text-ds-text-subtle dark:text-ds-text-disabled text-base">{cleanDescription}</p>;
    $[32] = cleanDescription;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t18 || $[35] !== t19) {
    t20 = <div>{t18}{t19}</div>;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t12 || $[38] !== t20) {
    t21 = <div className="mb-8"><div className="flex items-center gap-6">{t12}{t20}</div></div>;
    $[37] = t12;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t21 || $[41] !== t8) {
    t22 = <>{t8}{t21}</>;
    $[40] = t21;
    $[41] = t8;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  return t22;
}